var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_setup.BaseHeader),_c('main',[_vm._t("default",function(){return [_c('router-view')]})],2),_c(_setup.BaseFooter)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }